import axios from '../axios';

const endpoints = {
  getEdsInfo: (document_id: any) =>
    axios.get('/getInfoDocSign?document_id=' + document_id),
  getCount: () => axios.get('/coordination/count/signature'),
};

export default endpoints;
